<template>
  <div class="con4">
    <div class="container">
      <p class="text-title">영어 말하기 고민?<br />AI튜터 Plus로 완전 극복!</p>
      <img src="@/assets/img/aitutorplus/con4/img-m.png" alt="" class="img-m" />
      <img
        src="@/assets/img/aitutorplus/con4/img-pc.png"
        alt=""
        class="img-pc"
      />
      <p class="text0">걱정 마세요!</p>
      <p class="text1">
        AI튜터와 함께 라면,<br /><span
          >언제, 어디서든 자유롭게<br class="br-m" />
          영어로 대화</span
        >할 수 있어요!<br /><span
          >어색한 표현이나 문법도<br class="br-m" />
          당당하게 교정</span
        >
        받을 수 있어요!
      </p>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media screen and (min-width: 1200px) {
    padding: 0;
  }
}

.br-m {
  @media screen and (min-width: 1200px) {
    display: none;
  }
}

.con4 {
  padding: 86px 0;
  background-color: #f3f4f6;

  @media screen and (min-width: 1200px) {
    padding: 174px 0;
  }

  .text-title {
    font-size: 30px;
    font-weight: 700;
    color: #18181b;
    text-align: center;
    margin-bottom: 46px;

    @media screen and (min-width: 1200px) {
      font-size: 52px;
      margin-bottom: 82px;
    }
  }

  .img-m {
    width: 320px;
    margin: 0 auto 36px;

    @media screen and (min-width: 1200px) {
      display: none;
    }
  }

  .img-pc {
    display: none;

    @media screen and (min-width: 1200px) {
      display: block;
      width: 1132px;
      margin: 0 auto 24px;
    }
  }

  .text0 {
    font-size: 30px;
    font-weight: 700;
    color: #18181b;
    text-align: center;
    margin-bottom: 18px;

    @media screen and (min-width: 1200px) {
      font-size: 50px;
      margin-bottom: 50px;
    }
  }

  .text1 {
    font-size: 18px;
    color: #18181b;
    text-align: center;
    line-height: 28px;

    span {
      font-weight: 700;
    }

    @media screen and (min-width: 1200px) {
      font-size: 32px;
      line-height: 52px;
    }
  }
}
</style>
